import { getOwner } from "@ember/application"
import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type Router from "cc-frontend/router"
import { tracked } from "tracked-built-ins"

export default class AdminGoToDocument extends Component {
  @service("ember-store") store

  @service rpc

  @service session

  @tracked documentId: string = ""
  @tracked documentType: string | null = null

  @action
  goToDocument() {
    ;(getOwner(this)!.lookup("router:main") as Router).transitionTo(
      `admin.${this.documentType}`,
      this.documentId
    )
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    AdminGoToDocument: typeof AdminGoToDocument
  }
}
